import { ListeTable } from '@mairistem/liste';
import React from 'react';
import type RegleCalcul from '../../../../interfaces/simulation/regleCalcul';
import './RegleCalculListRow.css';

interface RegleCalculListRowProps {
	regleCalcul: RegleCalcul;
	rowProps: any;
}

const RegleCalculListRow = ({
	regleCalcul,
	rowProps,
}: RegleCalculListRowProps) => (
	<ListeTable.Row key={regleCalcul.identifiant} {...rowProps}>
		<ListeTable.Cell name="libelle" verticalAlign="middle">
			{regleCalcul.libelle}
		</ListeTable.Cell>
	</ListeTable.Row>
);

export default RegleCalculListRow;
